import { api } from "../lib/apiClient";
// eslint-disable-next-line no-unused-vars
import { TivConversation, TivConversationWithMessages, TivMessage, TivSendMessagePayload } from "../types/tiv";

/**
 * GET /tiv → récupère toutes les conversations tiv
 * @param {string} authToken
 * @returns {Promise<TivConversation[]>}
 */
export async function fetchTivConversations(authToken) {
  const { data } = await api.get("/tiv", {
    headers: { Authorization: `Bearer ${authToken}` },
  });
  return data;
}

/**
 * GET /tiv/:id → récupère une conversation tiv avec ses messages
 * @param {number} conversationId
 * @param {string} authToken
 * @returns {Promise<TivConversationWithMessages>}
 */
export async function fetchTivConversation(conversationId, authToken) {
  const { data } = await api.get(`/tiv/${conversationId}`, {
    headers: { Authorization: `Bearer ${authToken}` },
  });
  return data;
}

/**
 * POST /tiv → crée une conversation tiv
 * @param {Partial<TivConversation>} payload
 * @param {string} authToken
 * @returns {Promise<TivConversation>}
 */
export async function createTivConversation(payload, authToken) {
  const { data } = await api.post("/tiv", payload, {
    headers: { Authorization: `Bearer ${authToken}` },
  });
  return data;
}

/**
 * PATCH /tiv/:id → met à jour les fragments de la lettre
 * @param {number} conversationId
 * @param {{ lm_merged?: string, lm_max_char?: number }} payload
 * @returns {Promise<TivConversation>}
 */
export async function updateTivConversation(conversationId, payload) {
  const { data } = await api.patch(`/tiv/${conversationId}`, payload);
  return data;
}

/**
 * POST /tiv/:id/validate → valide la lettre
 * @param {number} conversationId
 * @returns {Promise<void>}
 */
export async function validateTivConversation(conversationId) {
  const { data } = await api.post(`/tiv/${conversationId}/validate`);
  return data;
}

/**
 * GET /tiv/profile/memory → récupère la mémoire profil de l'utilisateur
 * @returns {Promise<Array>}
 */
export async function fetchTivProfileMemory() {
  const { data } = await api.get('/tiv/profile/memory');
  return data;
}

/**
 * POST /tiv/:id/messages → envoie un message et récupère la réponse de tiv
 * @param {number} conversationId
 * @param {TivSendMessagePayload} payload
 * @param {string} authToken
 * @returns {Promise<TivMessage>}
 */
export async function sendTivMessage(conversationId, payload, authToken) {
  const { data } = await api.post(`/tiv/${conversationId}/messages`, payload, {
    headers: { Authorization: `Bearer ${authToken}` },
  });
  return data;
}
